import React from 'react';
import styled from 'styled-components';
import { Card, CardActions, Divider, Typography } from '@material-ui/core';

import CardTitle from './CardTitle';
import CardContent from './CardContent';

const StyledCard = styled(Card)`
  background-color: #f7f8fc;
  .no-content {
    font-style: italic;
  }
`;

export interface HoveredCardProps {
  title: string;
  className?: string;
  icon?: React.ReactNode;
  content?: React.ReactNode;
  actions?: React.ReactNode;
}

const HoveredCard: React.FC<HoveredCardProps> = (props: HoveredCardProps) => {
  const { title, icon, content, actions, className } = props;
  return (
    <StyledCard elevation={0} className={className}>
      <CardTitle>
        {icon}
        {title}
      </CardTitle>
      <CardContent>
        {content ? (
          content
        ) : (
          <Typography
            variant='body1'
            color='textSecondary'
            className='no-content'
          >
            No content available.
          </Typography>
        )}
      </CardContent>
      {actions && <CardActions>{actions}</CardActions>}
      <Divider />
    </StyledCard>
  );
};

export default HoveredCard;
